import React from 'react';
import PropTypes from 'prop-types';
import MuiTabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import { makeStyles } from '@material-ui/styles';

const useStyles = makeStyles(theme => ({
  root: {
    color: theme.palette.text.primary
  },
  indicator: {
    backgroundColor: theme.palette.secondary.main
  }
}));

const useStylesTab = makeStyles(theme => ({
  root: {
    '&:hover': {
      color: theme.palette.secondary.main,
      opacity: 1
    }
  },
  // if it's already selected, then we don't want to change the color
  selected: {
    '&:hover': {
      color: theme.palette.text.primary
    }
  }
}));

const Tabs = ({ tabLabels, activeTab = 0, handleTabClick }) => {
  const classes = useStyles();
  const tabClasses = useStylesTab();
  return (
    <MuiTabs value={activeTab} classes={classes}>
      {tabLabels.map(tab => {
        return (
          <Tab
            key={tab}
            data-testid={`${tab}-option-tab`}
            label={tab}
            onClick={() => handleTabClick(tab)}
            classes={tabClasses}
          />
        );
      })}
    </MuiTabs>
  );
};

Tabs.propTypes = {
  tabLabels: PropTypes.array.isRequired,
  activeTab: PropTypes.number.isRequired,
  handleTabClick: PropTypes.func.isRequired
};

export default Tabs;
